export class IncidentCommentDeleteCommand {
    constructor(
        public readonly VarianceId: string,
        public readonly CommentId: string,
        public readonly AddedBy: string,
    ) {}
}
